import * as React from "react";
import nextWithRedux from "next-redux-wrapper";
import { initStore } from "@grandvisionhq/state";
const withRedux = (App) => {
  class Wrapper extends React.Component {
    static async getInitialProps(props) {
      let pageProps = {};
      try {
        if (typeof App.getInitialProps === "function") {
          pageProps = await App.getInitialProps(props);
        }
      } finally {
        const { isServer, store } = props.ctx;
        if (isServer) {
          await store.close();
        }
      }
      return pageProps;
    }
    render() {
      return /* @__PURE__ */ React.createElement(App, { ...this.props });
    }
  }
  return nextWithRedux(initStore)(Wrapper);
};
export {
  withRedux
};
//# sourceMappingURL=with-redux.js.map
